module.exports = __webpack_public_path__ + "media/bootstrap-icons/toggles2-670316f5.svg";